<template>
  
  <!-- Banner Area -->
  <Banner />
 <Loader :active="loaderActive" />
  <!-- Top Service And Tour Area-->
  <TopService />

  <About />

  <!-- Find travel partner -->
  <FindTravellPartner />

  <!--Client Area -->
  <ClientSays />

  <!-- Our partners Area -->
  <Partners />

  <!-- Invisible iframe once loginUrl is available
  <iframe v-if="loginUrl && !loginComplete"
          ref="loginIframe"
          :src="loginUrl"
          style="display:none"
          @load="onIframeLoad">
  </iframe> -->
</template>
<script>
  import Banner from '@/components/home/BannerAir.vue'
  import TopService from '@/components/hometwo/TopService.vue'
  import About from '@/components/hometwo/About.vue'
  import FindTravellPartner from '@/components/hometwo/FindTravellPartner.vue'
  import ClientSays from '@/components/hometwo/ClientSays.vue'
  import Partners from '@/components/home/Partners.vue'
  import store from '@/store'
  import Loader from '@/components/Loader.vue'
  
  

export default {
  name: "RedirectView",
  components: {
    Banner, Partners, TopService, About, FindTravellPartner,ClientSays,Loader
  },
  data() {
    return {
      timeExpire : store.getters.alnSSOTimeExpire,
      username : store.getters.username, 
    //  loginComplete : false,
      redirect : 'https://res.vacationclubbenefits.com/app/0/air/0/search.html?siteid=58483&theme=standard',
      loginUrl : null,
      loaderActive: false
    }
  },
  watch: {
    '$store.getters.username' : function() {
      this.username = store.getters.username
      this.fetch()
    }
  },
  methods: {
   /* onIframeLoad() {
      if (!this.loginComplete) {
        console.log("WITHIN THE CONST IFRAMELOAD")
        console.log(this.loginUrl)
        this.loginComplete = true
        // Now redirect the main window
        // window.location.href = this.redirect
      }
    },*/
    fetch() {
      var curTime = Date.now()
      if (curTime > 4294967295) curTime = Math.floor(curTime / 1000)
      
      var str = this.$route.path.substring(0,4)
      console.log("START TRY AIR --- " + this.timeExpire +" --- " + curTime +" --- " + this.username)
      // /*
      if (str == '/air')
      {
        this.loaderActive = true
        //if (curTime > this.timeExpire)
        if (store.getters.isTransfer2Car != '' && this.username !== null)
        {
          //console.log("START TRY")
          //this.$urlRequest.post('accounts', 'airCheck')
          // .then((response) => {
          
             //  try {
             //   var response = await this.$urlRequest.post('accounts', 'carCheck') 
      
         
          var loginRedirect = 'https://res.vacationclubbenefits.com/app/0/air/0/search.html?siteid=58483&theme=standard&siteid=58483&customer_parameters[arn_siteid]=58483&customer_parameters[arn_theme]=standard&memberToken=' + store.getters.isTransfer2Car
          // response.redirect //+ "&redirect_uri=" + this.redirect
             //var loginRedirect = "https://jvgames.com"

             console.log("Air LOGIN")
             //console.log(response)

           //  if (loginRedirect !== null && loginRedirect != '')
            // {
            //   store.dispatch('UPDATE_USER', {
             ///    alnSSOTimeExpire : (curTime + 3580),
             //    isTransfer2Car : false
              // })
              // this.$urlRequest.cookies()

            
               this.loginUrl = loginRedirect
               console.log(this.loginUrl)
               this.loaderActive = true
               window.location.href = this.loginUrl
        //     }
        //   })
        //  .catch((error) => {
         //   console.log("Not logged in or error fetching token")
         //   console.log(error)
         // })
        }
        else
        {
          this.loaderActive = true
          window.location.href = this.redirect
        } 
      }

        
      // */
    
    },
  },
  mounted () {  // "https://car.flystaygo.com"
   
    this.fetch();
    }
}
</script>
